import { Component, OnInit, Input } from '@angular/core';
import { DacConfig } from 'app/shared/services/dac-config.service';

@Component({
  selector: 'dac-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input() fixedBottom:boolean;

  constructor(private dacConfig:DacConfig) { 
    this.fixedBottom = false;
  }

  ngOnInit() {
  }

  get supportEmail() {
    return this.dacConfig.supportEmail;
  }

  get supportPhone() {
    return this.dacConfig.supportPhone;
  }

  get copyrightTitle() {
    return this.dacConfig.copyrightTitle;
  }

  get mailLink() {
    return "mailto:" + this.supportEmail;
  }
  get phoneLink() {
    return "tel:" + this.supportPhone;
  }
  get copyrightURL() {
    return this.dacConfig.copyrightURL;
  }

}



// WEBPACK FOOTER //
// ./src/app/theme/footer/footer.component.ts